angular
    .module('app')
    .component('subjects', {
        templateUrl: '/templates/pages/subjects/subjects.html',
        controller: 'SubjectsController',
        controllerAs: 'vm',
    });